import { Validator } from '../../types/Validator';
import { ValidatorInterface } from '../../types/ValidatorInterface';
import { ValidatorRegistry } from '../../types/ValidatorRegistry';
import { PropertiesInterface } from '../../types/properties/Property';
import { ITypeValidatesIn } from './ITypeValidatesIn';

/**
 * @deprecated This class is deprecated and should not be used in new code.
 * Use InValidator from application-types instead.
 */
export class InValidator implements ValidatorInterface<ITypeValidatesIn> {
  name = 'In';

  friendlyName = 'One Of';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.in.description';

  types = ['String', 'Number', 'Option'];

  properties = {
    value: {
      friendlyName: 'shared.properties.validators.in.properties.friendlyName',
      default: [],
      type: 'Any',
      isArray: true,
      validators: [
        {
          name: 'Required',
          value: true,
        },
        {
          name: 'ArrayUnique',
          value: true,
        },
        {
          name: 'ArrayMin',
          value: 1,
        },
        {
          name: 'ArrayMax',
          value: 2 ** 6,
        },
      ],
    },
  } as PropertiesInterface;

  attach(type: ITypeValidatesIn) {
    type.addInValidator(this);
  }

  constructor(public config?: Validator) {}
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use In from application-types instead.
 */
const In = new InValidator(undefined);

ValidatorRegistry.register(InValidator, In.name);

export default In;
